module.exports = __webpack_public_path__ + "static/media/sharepoint-logo.9bcfa557.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/sharepoint-logo.svg
// module id = 1714
// module chunks = 0